<template>
  <div id="app">
    <!-- 正式三维地址 -->
    <!-- <iframe
      src="CY/mms3d/index.html"
      frameborder="0"
      id="iframe"
      class="iframe"
    ></iframe> -->
    <!-- 本地三维地址 -->
    <iframe
      src="mms3d/index.html"
      frameborder="0"
      id="iframe"
      class="iframe"
    ></iframe>
    <div
      class="bg"
      v-show="
        ['home', 'EdgeServer', 'Devicp', 'Devicg', 'Devicm'].includes(
          this.$route.name
        )
      "
    ></div>
    <!-- 头部 -->
    <Header></Header>
    <Bottom></Bottom>

    <!-- 主页底部按钮 -->
    <!-- <div
      class="button-nav-x"
      v-show="['home', 'EdgeServer'].includes(this.$route.name)"
    >
      <div class="gateway" :class="gateway ? 'gatewayA' : ''" @click="jumpG()">
        <span>边缘网关</span>
      </div>
      <div class="meter" :class="meter ? 'meterA' : ''" @click="jumpM()">
        <span>边缘仪表</span>
      </div>
      <div class="server" :class="server ? 'serverA' : ''" @click="jumpS()">
        <span>边缘服务器</span>
      </div>
    </div> -->
    <!-- 设备底部按钮 -->
    <div
      class="divceNav"
      v-show="['Devicp', 'Devicg', 'Devicm'].includes(this.$route.name)"
    >
      <div
        v-for="(item, index) in navItem"
        :key="index"
        :class="navActive === item.path ? 'divcenavA' : ''"
        @click="navChange(item, index)"
      >
        <span>{{ item.name }}</span>
      </div>
    </div>

    <!-- 悬浮弹框 -->
    <!-- 气体分析仪 -->
    <div class="kuang-g info">
      <div class="kuangClose" @click="kuangClose">x</div>
      <div class="title">气体分析仪</div>
      <ul>
        <li><span>浓度：</span>{{this.getGeneralEquipmentBulletFrameData.concentration}} %</li>
      </ul>
      <div class="more" @click="moreg">更多</div>
    </div>
    <!-- 气体分析仪 -->
    <div class="kuang-g info">
      <div class="kuangClose" @click="kuangClose">x</div>
      <div class="title">气体分析仪</div>
      <ul>
        <li><span>浓度：</span>{{this.getGeneralEquipmentBulletFrameData.concentration}} %</li>
      </ul>
      <div class="more" @click="moreg">更多</div>
    </div>
    <!-- 气体分析仪 -->
    <div class="kuang-g info">
      <div class="kuangClose" @click="kuangClose">x</div>
      <div class="title">气体分析仪</div>
      <ul>
        <li><span>浓度：</span>{{this.getGeneralEquipmentBulletFrameData.concentration}} %</li>
      </ul>
      <div class="more" @click="moreg">更多</div>
    </div>

    <!-- 流量计 -->
    <div class="kuang-liu info">
      <div class="kuangClose" @click="kuangClose">x</div>
      <div class="title">流量计</div>
      <ul>
        <li><span>瞬时流量：</span>{{this.getGeneralEquipmentBulletFrameData.currentFlow}}M3/H</li>
        <li><span>累计流量：</span>{{this.getGeneralEquipmentBulletFrameData.totalFlow}}M3/H</li>
        <li><span>方向：</span>{{this.getGeneralEquipmentBulletFrameData.direct}}</li>
      </ul>
      <div class="more" @click="morem">更多</div>
    </div>
    <!-- 流量计 -->
    <div class="kuang-liu info">
      <div class="kuangClose" @click="kuangClose">x</div>
      <div class="title">流量计</div>
      <ul>
        <li><span>瞬时流量：</span>{{this.getGeneralEquipmentBulletFrameData.currentFlow}}M3/H</li>
        <li><span>累计流量：</span>{{this.getGeneralEquipmentBulletFrameData.totalFlow}}M3/H</li>
        <li><span>方向：</span>{{this.getGeneralEquipmentBulletFrameData.direct}}</li>
      </ul>
      <div class="more" @click="morem">更多</div>
    </div>

    <!-- 流量计 -->
    <div class="kuang-liu info">
      <div class="kuangClose" @click="kuangClose">x</div>
      <div class="title">流量计</div>
      <ul>
        <li><span>瞬时流量：</span>{{this.getGeneralEquipmentBulletFrameData.currentFlow}}M3/H</li>
        <li><span>累计流量：</span>{{this.getGeneralEquipmentBulletFrameData.totalFlow}}M3/H</li>
        <li><span>方向：</span>{{this.getGeneralEquipmentBulletFrameData.direct}}</li>
      </ul>
      <div class="more" @click="morem">更多</div>
    </div>

    <!-- 流量计 -->
    <div class="kuang-liu info">
      <div class="kuangClose" @click="kuangClose">x</div>
      <div class="title">流量计</div>
      <ul>
        <li><span>瞬时流量：</span>{{this.getGeneralEquipmentBulletFrameData.currentFlow}}M3/H</li>
        <li><span>累计流量：</span>{{this.getGeneralEquipmentBulletFrameData.totalFlow}}M3/H</li>
        <li><span>方向：</span>{{this.getGeneralEquipmentBulletFrameData.direct}}</li>
      </ul>
      <div class="more" @click="morem">更多</div>
    </div>

    

    <!-- 压力变送器 -->
    <div class="kuang-p info">
      <div class="kuangClose" @click="kuangClose">x</div>
      <div class="title">压力变送器</div>
      <ul>
        <li><span>压力：</span>{{this.getGeneralEquipmentBulletFrameData.currentPs}}MPA</li>
      </ul>
      <div class="more" @click="morep">更多</div>
    </div>

    <!-- 流量计 -->
    <div class="kuang-liu info">
      <div class="kuangClose" @click="kuangCloseInside">x</div>
      <div class="title">流量计</div>
      <ul>
        <li><span>瞬时流量：</span>{{this.getGeneralEquipmentBulletFrameData.currentFlow}}M3/H</li>
        <li><span>累计流量：</span>{{this.getGeneralEquipmentBulletFrameData.totalFlow}}M3/H</li>
        <li><span>方向：</span>{{this.getGeneralEquipmentBulletFrameData.direct}}</li>
      </ul>
      <div class="more" @click="morem">更多</div>
    </div>


    

    <!-- 压力变送器 -->
    <div class="kuang-p info">
      <div class="kuangClose" @click="kuangClose">x</div>
      <div class="title">压力变送器</div>
      <ul>
        <li><span>压力：</span>{{this.getGeneralEquipmentBulletFrameData.currentPs}}MPA</li>
      </ul>
      <div class="more" @click="morep">更多</div>
    </div>
    <!-- 膜池设备间 -->
    <div class="kaung info">
      <div class="kuangClose" @click="kuangClose">x</div>
      <div class="title">膜池设备间</div>
      <ul>
        <li><span>设备间温度：</span>17 Oc</li>
        <li><span>瞬时流量：</span>M3/H</li>
        <li><span>膜池液位：</span>0.80M</li>
        <li><span>膜池压力：</span>7.83KPA</li>
        <li><span>能耗总累计：</span>56077.56KW.H</li>
        <li><span>流量总累计：</span>4097.07M3</li>
      </ul>
      <div class="more" @click="morep">更多</div>
    </div>
    <!-- 边缘服务器 -->
    <div class="kaung-s info">
      <div class="title">边缘服务器</div>
      <ul>
        <li><span>CPU使用率：</span>17 Oc</li>
        <li><span>内存使用率：</span>M3/H</li>
        <li><span>磁盘使用率：</span>0.80M</li>
        <li><span>TCP连接数：</span>7.83KPA</li>
        <li><span>上行：</span>56077.56KW.H</li>
        <li><span>连接状态：</span>4097.07M3</li>
        <li><span>上传带宽：</span>4097.07M3</li>
      </ul>
      <div class="more" @click="morep">更多</div>
    </div>

    <!-- 膜池电机设备 -->
    <div class="kuang-mo info">
      <div class="title">膜池电机设备</div>
      <div class="kuang-e"></div>
      <div class="more" @click="morem">更多</div>
    </div>

    <!-- 边缘网关 -->
    <div class="kuang-way info">
      <div class="title">边缘网关</div>
      <ul>
        <li><span>网络状态：</span></li>
        <li><span>上行：</span>正常/掉线</li>
        <li><span>下型：</span>正常/掉线</li>
        <li><span>通信速率：</span>1.2MB</li>
      </ul>
      <div class="more" @click="morem">更多</div>
    </div>

    <!-- 返回 -->
    <div
      class="back"
      @click="back()"
      v-show="
        [
          'Devicp',
          'Devicg',
          'Devicm',
          'EdgeServer',
          'GateWay',
          'Inside',
        ].includes(this.$route.name)
      "
    ></div>
    <!-- <div id="kkkk">123</div>  -->
    <!-- 主页面 -->
    <router-view :needData="this.devicId" :needWayName="this.wayName"></router-view>
  </div>
</template>

<script>
//import {getGeneralEquipmentBulletFrame} from "./api/api"
import Bottom from "./components/bottom.vue";
import Header from "./components/header.vue";

export default {
  name: "App",
  data() {
    return {
      bottomShow: true,
      gateway: false,
      meter: false,
      server: false,
      kkk: "",
      devicId: "",
      navActive: "/devicp",
      getGeneralEquipmentBulletFrameData:"", //弹框数据
      wayName:'',

      // navActive: "",
      navItem: [
        {
          name: "边缘压力仪表",
          path: "/devicp",
        },
        {
          name: "边缘气体仪表",
          path: "/devicg",
        },
        {
          name: "边缘流量仪表",
          path: "/devicm",
        },
      ],
    };
  },
  created(){
    if(this.$router.path !== '/home') {
      this.$router.replace('/')
    }
  },
  mounted() {
    // this.$router.push({
    //   path: "/",
    // });
    window.inside = this.inside;
    window.backTu = this.backTu;
    window.jumpS = this.jumpS;
    window.jumpG = this.jumpG;
    window.equipmentId = this.equipmentId; //chuanrushebeiId

    // this.bottomShow = includes(this.$route.name)
    // this.jump();
    // console.log(this.$route.name);
    // console.log(["home"].includes(this.$route.name));
  },
  watch: {
    $route: "ppp",
  },
  components: {
    Bottom,
    Header,
  },
  methods: {
    equipmentId(id) {
      console.log(id, "设备id");
      this.devicId = id;
//    var param = {
//      devId:id
//    }
//    //弹框设备
//    getGeneralEquipmentBulletFrame(param).then((res)=>{
//      // console.log(res);
//      this.getGeneralEquipmentBulletFrameData = res.data;
//    })
    this.getGeneralEquipmentBulletFrameData = {"currentFlow":5,"totalFlow" :10,"direct":"正","concentration":50,"currentPs":60};
    },
    jumpM() {
      this.meter = !this.meter;

      this.$router.push({
        path: "/devicp",
      });

      this.gateway = false;
      this.server = false;
      document.getElementById("iframe").contentWindow.MMAPI.show1(3);
      this.navActive = "/devicp";
    },
    jumpG(name) {
      console.log(name); 
      this.wayName = name
      this.gateway = !this.gateway;

      this.$router.push({
        path: "/gateWay",
      });
      this.meter = false;
      this.server = false;

      document.getElementById("iframe").contentWindow.MMAPI.show1(4);
    },
    jumpS() {
      this.server = !this.server;
      setTimeout(() => {
        this.$router.push({
          path: "/edgeServer",
        });
      }, 500);
      this.gateway = false;
      this.meter = false;
    },
    navChange(item, index) {
      console.log(item, index, "aaaa");
      this.navActive = item.path;
      this.$router.push({
        path: item.path,
      });
      if (index == 0) {
        document.getElementById("iframe").contentWindow.MMAPI.show1(3);
      } else if (index == 1) {
        document.getElementById("iframe").contentWindow.MMAPI.show1(2);
      } else if (index == 2) {
        document.getElementById("iframe").contentWindow.MMAPI.show1(1);
      }
    },
    ppp() {
      if (["home"].includes(this.$route.name) == true) {
        this.gateway = false;
        this.meter = false;
        this.server = false;
      }
    },
    morep() {
      this.$router.push({
        path: "/devicp",
      });
      document.getElementById("iframe").contentWindow.MMAPI.show1(3);
      this.navActive = "/devicp";
    },
    moreg() {
      this.$router.push({
        path: "/devicg",
      });
      document.getElementById("iframe").contentWindow.MMAPI.show1(2);
      this.navActive = "/devicg";
    },
    morem() {
      this.$router.push({
        path: "/devicm",
      });
      document.getElementById("iframe").contentWindow.MMAPI.show1(1);
      this.navActive = "/devicm";
    },
    back() {
      this.$router.go(-1);
      setTimeout(() => {
        if (this.$route.name == "home") {
          document.getElementById("iframe").contentWindow.MMAPI.show1(0);
        } else if (this.$route.name == "GateWay") {
          document.getElementById("iframe").contentWindow.MMAPI.show1(4);
        } else {
          this.$router.push({
            path: "/",
          });
          document.getElementById("iframe").contentWindow.MMAPI.show1(0);
        }
      }, 10);
    },
    inside() {
      this.$router.push({
        path: "/inside",
      });
      document.getElementById("iframe").contentWindow.MMAPI.show1(5);
    },
    kuangClose() {
      document.getElementById("iframe").contentWindow.backTu();
    },
    kuangCloseInside(){
       document.getElementById("iframe").contentWindow.backTu1();
    }
  },
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* background: url("./assets/img/bg-shadow.png") no-repeat; */
  /* pointer-events: none; */
  overflow: hidden;
  position: relative;
}
.kkkkkk {
  width: auto;
  height: auto;
}

.back {
  width: 1.8vw;
  height: 3.6vh;
  position: absolute;
  background: url("../src/assets/img/back.png") no-repeat;
  right: 2.1vw;
  top: 8vh;
  cursor: pointer;
  z-index: 10;
}

@font-face {
  font-family: SIMHEI;
  src: url("./assets/font/SIMHEI.TTF");
}
@font-face {
  font-family: pangmenzhengdao;
  src: url("./assets/font/PANGMEN.TTF");
}
/* 膜池设备间 */
.kaung {
  width: 222px;
  height: 211px;
  position: absolute;
  background: url("../src/assets/img/kuang.png") no-repeat;
  display: none;
}
.info .kuangClose {
  width: 10px;
  height: 10px;
  position: absolute;
  right: 0.8vw;
  top: 0.5vh;
  cursor: pointer;
  color: #ccc;
}
.kaung .title {
  width: 100%;
  height: 3.1vh;
  color: #fff;
  font-size: 0.75vw;
  font-family: pangmenzhengdao;
  line-height: 4.5vh;
}
.kaung ul {
  width: 100%;
  height: 120px;
  display: flex;
  flex-wrap: wrap;
}

.kaung ul li {
  width: 80%;
  color: #fff;
  font-size: 0.6vh;
  display: flex;
  margin-top: 0.5vh;
  margin-left: 1vw;
  font-family: SIMHEI;
}
.kaung ul li span {
  color: #a7e5f5;
}
.kaung .more {
  width: 47px;
  height: 15px;
  font-size: 0.6vw;
  color: #fff;
  background: #1b96b8;
  margin-top: 0.5vh;
  margin-left: 90px;
  cursor: pointer;
  font-family: SIMHEI;
}
/* 边缘服务器 */
.kaung-s {
  width: 222px;
  height: 260px;
  position: absolute;
  background: url("../src/assets/img/kuang.png") no-repeat;
  background-size: 100% 85%;
  display: none;
}
.kaung-s .title {
  width: 100%;
  height: 3.1vh;
  color: #fff;
  font-size: 0.75vw;

  font-family: pangmenzhengdao;
  /* font-weight: 600; */
  line-height: 4.5vh;
}
.kaung-s ul {
  width: 100%;
  height: 130px;
  display: flex;
  flex-wrap: wrap;
}

.kaung-s ul li {
  width: 80%;
  color: #fff;
  font-size: 0.6vh;
  display: flex;
  margin-top: 5px;
  margin-left: 1vw;
  font-family: SIMHEI;
}
.kaung-s ul li span {
  color: #a7e5f5;
}
.kaung-s .more {
  width: 47px;
  height: 15px;
  font-size: 0.6vw;
  color: #fff;
  background: #1b96b8;
  margin-top: 0.5vh;
  margin-left: 90px;
  cursor: pointer;
  font-family: SIMHEI;
}
/* 流量计 */
.kuang-liu {
  display: none;
  width: 177px;
  height: 146px;
  position: absolute;
  background: url("../src/assets/img/kuang-liu.png") no-repeat;
}
.kuang-liu .title {
  width: 100%;
  height: 3.1vh;
  color: #fff;
  font-size: 0.6vw;
  font-weight: 600;
  line-height: 40px;
}

.kuang-liu ul {
  width: 100%;
  height: 58px;
  display: flex;
  flex-wrap: wrap;
}

.kuang-liu ul li {
  width: 85%;
  color: #fff;
  font-size: 0.6vw;
  display: flex;
  margin-top: 0.5vh;
  margin-left: 1vw;
  font-family: SIMHEI;
}
.kuang-liu ul li span {
  color: #a7e5f5;
}
.kuang-liu .more {
  width: 47px;
  height: 15px;
  font-size: 12px;
  color: #fff;
  background: #1b96b8;
  margin-top: 0.5vh;
  margin-left: 65px;
  cursor: pointer;
}

/* 气体分析仪 */
.kuang-g {
  display: none;
  width: 177px;
  height: 146px;
  position: absolute;
  background: url("../src/assets/img/kuang-liu.png") no-repeat;
}
.kuang-g .title {
  width: 100%;
  height: 3.1vh;
  color: #fff;
  font-size: 0.6vw;
  font-weight: 600;
  line-height: 40px;
}

.kuang-g ul {
  width: 100%;
  height: 58px;
  display: flex;
  flex-wrap: wrap;
}

.kuang-g ul li {
  width: 85%;
  color: #fff;
  font-size: 0.6vw;
  display: flex;
  margin-top: 0.5vh;
  margin-left: 1vw;
  font-family: SIMHEI;
}
.kuang-g ul li span {
  color: #a7e5f5;
}
.kuang-g .more {
  width: 47px;
  height: 15px;
  font-size: 12px;
  color: #fff;
  background: #1b96b8;
  margin-top: 0.5vh;
  margin-left: 65px;
  cursor: pointer;
}

/* 气体分析仪 */
.kuang-p {
  display: none;
  width: 177px;
  height: 146px;
  position: absolute;
  background: url("../src/assets/img/kuang-liu.png") no-repeat;
}
.kuang-p .title {
  width: 100%;
  height: 3.1vh;
  color: #fff;
  font-size: 0.6vw;
  font-weight: 600;
  line-height: 40px;
}

.kuang-p ul {
  width: 100%;
  height: 58px;
  display: flex;
  flex-wrap: wrap;
}

.kuang-p ul li {
  width: 85%;
  color: #fff;
  font-size: 0.6vw;
  display: flex;
  margin-top: 0.5vh;
  margin-left: 1vw;
  font-family: SIMHEI;
}
.kuang-p ul li span {
  color: #a7e5f5;
}
.kuang-p .more {
  width: 47px;
  height: 15px;
  font-size: 12px;
  color: #fff;
  background: #1b96b8;
  margin-top: 0.5vh;
  margin-left: 65px;
  cursor: pointer;
}
/* 膜池电机设备 */
.kuang-mo {
  display: none;
  width: 222px;
  height: 179px;
  position: absolute;
  background: url("../src/assets/img/kuang-mo.png") no-repeat;
}
.kuang-mo .title {
  width: 100%;
  height: 3.1vh;
  color: #fff;
  font-size: 0.75vw;
  font-weight: 600;
  line-height: 40px;
}
.kuang-mo .kuang-e {
  width: 100%;
  height: 95px;
  margin-left: 1vw;
  background: url("../src/assets/img/eee.png") no-repeat;
}
.kuang-mo .more {
  width: 47px;
  height: 15px;
  font-size: 12px;
  color: #fff;
  background: #1b96b8;
  margin-top: 0.5vh;
  margin-left: 85px;
  cursor: pointer;
}
/* 边缘网关 */
.kuang-way {
  display: none;
  width: 222px;
  height: 179px;
  position: absolute;
  background: url("../src/assets/img/kuang-mo.png") no-repeat;
}
.kuang-way .title {
  width: 100%;
  height: 3.1vh;
  color: #fff;
  font-size: 0.75vw;
  font-weight: 600;
  line-height: 40px;
}
.kuang-way ul {
  width: 100%;
  height: 85px;
  display: flex;
  flex-wrap: wrap;
}

.kuang-way ul li {
  width: 85%;
  color: #fff;
  font-size: 0.6vw;
  display: flex;
  margin-top: 0.5vh;
  margin-left: 1vw;
  font-family: SIMHEI;
}
.kuang-way ul li span {
  color: #a7e5f5;
}
.kuang-way .more {
  width: 47px;
  height: 15px;
  font-size: 12px;
  color: #fff;
  background: #1b96b8;
  margin-top: 0.5vh;
  margin-left: 85px;
  cursor: pointer;
}

.iframe {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
}

.button-nav-x {
  width: 31.66vw;
  height: 6.2vh;
  position: absolute;
  bottom: 3.2vh;
  left: 34.37vw;
  background: url("../src/assets/img/bottomNav-bg.png") no-repeat;
  display: flex;
  justify-content: space-around;
}

.button-nav-x div {
  width: 6.51vw;
  height: 3.7vh;
  line-height: 3.7vh;
  text-indent: 2.2vw;
  font-size: 0.85vw;
  /* font-size: 16px; */
  font-family: pangmenzhengdao;
  cursor: pointer;
  z-index: 1;
  display: flex;
}

.button-nav-x div:nth-child(1) {
  margin-left: 1vw;
}

.button-nav-x div span {
  background-image: -webkit-linear-gradient(bottom, #70cee6, #ffffff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gateway {
  background: url("../src/assets/img/gateway.png") no-repeat;
}
.gatewayA {
  background: url("../src/assets/img/gatewayA.png") no-repeat;
}

.meter {
  background: url("../src/assets/img/meter.png") no-repeat;
}
.meterA {
  background: url("../src/assets/img/meterA.png") no-repeat;
}
.server {
  background: url("../src/assets/img/seave.png") no-repeat;
}
.serverA {
  background: url("../src/assets/img/seaveA.png") no-repeat;
}

.divceNav {
  width: 31.66vw;
  height: 6.2vh;
  position: absolute;
  bottom: 3.1vh;
  left: 37.5vw;
  display: flex;
  justify-content: space-around;
  z-index: 7;
}

.divceNav div {
  width: 8.54vw;
  height: 4.3vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("../src/assets/img/devicenav.png") no-repeat;
  cursor: pointer;
}

.divceNav .divcenavA {
  background: url("../src/assets/img/devicenavA.png") no-repeat;
}

.divceNav div span {
  font-size: 0.75vw;
  background-image: -webkit-linear-gradient(bottom, #70cee6, #ffffff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: pangmenzhengdao;
}

.bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: url("./assets/img/bg-shadow.png") no-repeat;
  background-size: 100% 100%;
  pointer-events: none;
}

body,
html {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

ul {
  margin: 0;
  padding: 0;
}

li {
  list-style: none;
}

i {
  font-style: normal;
}
</style>
